import { UploadOutlined } from '@ant-design/icons'
import { Typography, Upload } from '@surecompanies/core_components'
import React, { useCallback } from 'react'
import styles from './CensusOnboardingFileDropzone.module.scss'

interface ParsedFileSummary {
  fileName: string
  recordCount: number
  columnCount: number
}

interface CensusOnboardingFileDropzoneProps {
  parsedFile: ParsedFileSummary | null
  onFileSelected: (file: File) => Promise<void> | void
  emptyHint: React.ReactNode
  loadedHint?: React.ReactNode
  disabled?: boolean
}

export default function CensusOnboardingFileDropzone({
  parsedFile,
  onFileSelected,
  emptyHint,
  loadedHint,
  disabled,
}: CensusOnboardingFileDropzoneProps) {
  const handleBeforeUpload = useCallback(
    (file: File) => {
      void onFileSelected(file)
      return false
    },
    [onFileSelected]
  )

  return (
    <div
      className={`${styles.dropzone} ${parsedFile ? styles.dropzoneLoaded : ''}`}
    >
      <Upload.Dragger
        accept=".csv,.xlsx,.xls"
        beforeUpload={handleBeforeUpload}
        maxCount={1}
        multiple={false}
        openFileDialogOnClick
        showUploadList={false}
        disabled={disabled}
      >
        <div className={styles.content}>
          <div
            className={`${styles.icon} ${parsedFile ? styles.iconLoaded : ''}`}
          >
            <UploadOutlined />
          </div>
          {parsedFile ? (
            <>
              <div className={styles.text}>
                Loaded {parsedFile.recordCount} records:{' '}
                {parsedFile.columnCount} columns found
              </div>
              <Typography.Text className={styles.hint}>
                {loadedHint ??
                  `${parsedFile.fileName} - Drag and drop a new file or click to replace`}
              </Typography.Text>
            </>
          ) : (
            <>
              <div className={styles.text}>
                Drag and drop a CSV or XLSX file here
              </div>
              <Typography.Text className={styles.hint}>
                {emptyHint}
              </Typography.Text>
            </>
          )}
        </div>
      </Upload.Dragger>
    </div>
  )
}
